module.exports = __webpack_public_path__ + "static/media/connection-0.c413eaf9.svg";